document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById('security-tabs');
  if (!section) return;

  const tabs = section.querySelectorAll('.security-tabs__tab');
  const panelsContent = section.querySelectorAll('.security-tabs__tab-panel--content');
  const imageSlides = section.querySelectorAll('.security-tabs__image-slide');
  const dividerItems = section.querySelectorAll('.security-tabs__divider-item');
  const prevBtn = section.querySelector('.security-tabs__arrow--prev');
  const nextBtn = section.querySelector('.security-tabs__arrow--next');
  const currentSpan = section.querySelector('.security-tabs__current');
  
  const totalTabs = tabs.length;
  let currentIndex = 0;
  const mobileBreakpoint = 900;

  function isMobile() {
    return window.innerWidth <= mobileBreakpoint;
  }

  // Initialize video functionality
  initVideoPlayers();

  function initVideoPlayers() {
    const videos = section.querySelectorAll('.security-tabs__video');
    
    videos.forEach(video => {
      const wrapper = video.closest('.security-tabs__video-wrapper');
      const replayBtn = wrapper.querySelector('.security-tabs__replay-btn-replay');
      const pauseBtn = wrapper.querySelector('.security-tabs__replay-btn-pause');
      if (!replayBtn) return;
      
      // Show replay button when video ends
      video.addEventListener('ended', () => {
        wrapper.classList.add('paused');
      });
      
      // Hide replay button when video starts playing
      video.addEventListener('play', () => {
        wrapper.classList.remove('paused');
      });
      
      // Replay button click handler
      replayBtn.addEventListener('click', () => {
        video.currentTime = 0;
        video.play();
        wrapper.classList.remove('paused');
      });

      pauseBtn.addEventListener('click', () => {
        video.pause();
        wrapper.classList.add('paused');
      });
    });
  }

  function getVisibleVideo(slide) {
    // Check if we're on mobile or desktop based on viewport
    const isMobile = window.innerWidth <= 900;
    const desktopWrapper = slide.querySelector('.security-tabs__video-wrapper--desktop');
    const mobileWrapper = slide.querySelector('.security-tabs__video-wrapper--mobile');
    
    if (isMobile && mobileWrapper) {
      return mobileWrapper.querySelector('.security-tabs__video');
    } else if (!isMobile && desktopWrapper) {
      return desktopWrapper.querySelector('.security-tabs__video');
    }
    
    return null;
  }

  function playVideoInSlide(slide) {
    const video = getVisibleVideo(slide);
    if (video) {
      video.currentTime = 0;
      video.play().catch(() => {
        // Autoplay might be blocked, that's okay
      });
    }
  }

  function pauseAllVideos() {
    const videos = section.querySelectorAll('.security-tabs__video');
    videos.forEach(video => {
      video.pause();
    });
    
    // Hide all replay buttons
    const replayBtns = section.querySelectorAll('.security-tabs__replay-btn');
    replayBtns.forEach(btn => {
      btn.classList.remove('paused');
    });
  }

  function updateTab(newIndex) {
    // Disable loop/circular navigation - no looping on any device
    if (newIndex < 0) newIndex = 0;
    if (newIndex >= totalTabs) newIndex = totalTabs - 1;
    
    // Pause all videos before switching
    pauseAllVideos();
    
    // Update tabs
    tabs.forEach((tab, index) => {
      tab.classList.toggle('active', index === newIndex);
    });
    
    // Update panels
    panelsContent.forEach((panelContent, index) => {
      panelContent.classList.toggle('active', index === newIndex);
    });
    
    // Update images
    imageSlides.forEach((slide, index) => {
      const isActive = index === newIndex;
      slide.classList.toggle('active', isActive);
      
      // Play video if this slide is now active
      if (isActive) {
        playVideoInSlide(slide);
      }
    });
    
    // Update divider items
    dividerItems.forEach((item, index) => {
      item.classList.toggle('active', index === newIndex);
    });
    
    currentIndex = newIndex;
    
    // Update pagination
    if (currentSpan) {
      currentSpan.textContent = currentIndex + 1;
    }

    // Update button disabled states on mobile
    updateButtonStates();
  }

  function updateButtonStates() {
    // Disable buttons at boundaries on all devices
    if (prevBtn) {
      prevBtn.disabled = currentIndex === 0;
      prevBtn.classList.toggle('disabled', currentIndex === 0);
    }
    if (nextBtn) {
      nextBtn.disabled = currentIndex === totalTabs - 1;
      nextBtn.classList.toggle('disabled', currentIndex === totalTabs - 1);
    }
  }

  // Tab click handler
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => updateTab(index));
  });

  // Arrow navigation
  if (prevBtn) {
    prevBtn.addEventListener('click', () => {
      // Prevent navigation if at first tab
      if (currentIndex === 0) return;
      updateTab(currentIndex - 1);
    });
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', () => {
      // Prevent navigation if at last tab
      if (currentIndex === totalTabs - 1) return;
      updateTab(currentIndex + 1);
    });
  }

  // Update button states on window resize
  window.addEventListener('resize', updateButtonStates);
  
  // Initialize button states
  updateButtonStates();

  // Touch/swipe support for mobile
  let touchStartX = 0;
  let touchEndX = 0;
  const swipeArea = section.querySelector('.security-tabs__content');

  if (swipeArea) {
    swipeArea.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    swipeArea.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      handleSwipe();
    }, { passive: true });
  }

  function handleSwipe() {
    const swipeThreshold = 50;
    const diff = touchStartX - touchEndX;
    
    if (Math.abs(diff) > swipeThreshold) {
      if (diff > 0) {
        // Swipe left - go to next tab
        if (currentIndex === totalTabs - 1) return;
        updateTab(currentIndex + 1);
      } else {
        // Swipe right - go to previous tab
        if (currentIndex === 0) return;
        updateTab(currentIndex - 1);
      }
    }
  }

  // Play video in the initially active slide
  const initialActiveSlide = section.querySelector('.security-tabs__image-slide.active');
  if (initialActiveSlide) {
    // Use Intersection Observer to play video when section is visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          playVideoInSlide(initialActiveSlide);
          observer.disconnect();
        }
      });
    }, { threshold: 0.3 });
    
    observer.observe(section);
  }
});

class FadeInAnimation extends HTMLElement {
  constructor() {
    super();
    this.textRevealAnimationNodes = this.querySelectorAll('text-reveal-animation.animated-text-container');
    this.triggerElementClassName = this.getAttribute('trigger-element');
    this.observer = null;
    this.hasTriggered = false;
  }
  
  connectedCallback() {
    this.initIntersectionObserver();
  }
  
  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }
  
  initIntersectionObserver() {
    const triggerElement = document.querySelector(`.${this.triggerElementClassName}`);
    if (!triggerElement) return;
    
    // triggerHook: 0.8 相当于元素进入视口 20% 时触发
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.hasTriggered) {
          this.hasTriggered = true;
          
          // 添加 active 类触发淡入动画
          triggerElement.classList.add('active');
          
          if (this.textRevealAnimationNodes.length > 0) {
            this.textRevealAnimationNodes.forEach(node => {
              node.play();
            });
          }
          
          // 只触发一次，之后停止观察
          this.observer.unobserve(triggerElement);
        }
      });
    }, {
      threshold: 0,
      rootMargin: '-20% 0px 0px 0px' // 相当于 triggerHook: 0.8
    });
    
    this.observer.observe(triggerElement);
  }
}

customElements.define('fade-in-animation', FadeInAnimation);